import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/services/common/alert.service';
import { LoginService } from '../login/login.service';
import { BusinessUserService } from 'src/app/services/business-user.service';
import { StorageKey, StorageService } from 'src/app/services/common/storage.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { RoleManagementService } from 'src/app/services/role-management.service';
import { isPartnerPortalUser } from 'src/app/services/common/constant.service';

@Component({
  selector: 'app-otp-validate',
  templateUrl: './otp-validate.component.html',
  styleUrls: ['./otp-validate.component.scss']
})
export class OtpValidateComponent implements OnInit {

  isButtonDisabled = true;
  showTimer = false;
  loginForm: FormGroup;
  email: any;
  ID: any;
  businessId: any;
  businesslogo: string = "./assets/images/logo-inner.png";
  menuRights: any[] = [];

  timer: string = '03:00'; // Initialize with 1 minutes
  interval: any;

  get f() { return this.loginForm.controls; }
  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private businessUserService: BusinessUserService,
    private storageService: StorageService,
    private userInfoService: UserInfoService,
    private roleManagementService: RoleManagementService
  ) { }

  ngOnInit() {
    const queryString = this.activatedRoute.snapshot.queryParams;

    if (queryString?.ID) {
      try {
        const decodedString = window.atob(queryString.ID);
        const data = JSON.parse(decodedString);

        if (data?.email && data?.id) {
          this.email = data.email;
          this.ID = data.id;
          this.businessId = data.businessId;

          if (data.businessId) {
            this.businessUserService.detail_logo(this.businessId).subscribe((res: any) => {
              if (res.success && res.data?.logo) {
                this.businesslogo = res.data.logo
              }
            })
          }
          this.onSendAgainOTP();
        } else {
          this.router.navigate(['login']);
        }
      } catch (error) {
        this.router.navigate(['login']);
      }
    } else {
      this.alertService.showError("Invalid link");
      this.router.navigate(['login']);
    }
    this.buildForm();

    // Listen for changes in the form
    this.loginForm.valueChanges.subscribe(() => {
      this.checkEmptyFields();
    });
  }

  buildForm() {
    this.loginForm = this.formBuilder.group({
      digit1: [''],
      digit2: [''],
      digit3: [''],
      digit4: [''],
      digit5: [''],
      digit6: ['']
    }
    );
  }

  startTimer() {
    this.showTimer = true;

    let totalTime = 180; // 3 minutes in seconds

    this.interval = setInterval(() => {
      const minutes = Math.floor(totalTime / 60);
      const seconds = totalTime % 60;

      // Update timer display
      this.timer = `${this.padNumber(minutes)}:${this.padNumber(seconds)}`;

      // Stop timer when it reaches zero
      if (totalTime === 0) {
        this.showTimer = false;
        clearInterval(this.interval);
      }

      totalTime--;
    }, 1000);
  }

  padNumber(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  checkEmptyFields(): void {
    const values = Object.values(this.loginForm.value);
    this.isButtonDisabled = values.some((value) => !value); // Check if any field is empty
  }

  onInput(current: HTMLInputElement, next: HTMLInputElement | null): void {
    if (current.value.length === 1 && next) {
      next.focus();
    }
  }

  onKeyDown(event: KeyboardEvent, current: HTMLInputElement, prev: HTMLInputElement | null): void {
    if (event.key === 'Backspace' && !current.value && prev) {
      prev.focus();
      prev.value = ''; // Clear the previous input if you want
    }
  }

  onSubmit() {
    const otp = Object.values(this.loginForm.value).join('');

    this.loginService.validate_otp(this.ID, otp).subscribe({
      next: (response: any) => {
        if (response.success) {
          if (this.handleOtpLogin(response)) {
            return;
          }

          this.router.navigate(['login']);
        }
      }
    });
  }

  private handleOtpLogin(response: any): boolean {
    const data = response?.data || {};
    const token = data?.token || data?.authToken || data?.accessToken || response?.token;
    const userData = data?.userInfo || data?.user || data?.loginUserInfo || response?.userInfo;

    if (!token || !userData) return false;

    this.storageService.setValue(StorageKey.currentUser, JSON.stringify(userData));
    this.storageService.setValue(StorageKey.authToken, token);
    this.userInfoService.setUserInfo(userData);
    this.userInfoService.setLoginFlag(true);
    this.userInfoService.setToken(token);
    this.storageService.loginSubject.next(true);

    if (this.isSubscriptionActive(userData)) {
      this.roleManagementService.access().subscribe((menuResponse: any) => {
        this.menuRights = menuResponse?.success && Array.isArray(menuResponse?.data) ? menuResponse.data : [];
        this.storageService.setValue(StorageKey.menuRights, JSON.stringify(this.menuRights));
        this.storageService.menuListSubject.next(true);
      }, () => {
        this.menuRights = [];
        this.storageService.setValue(StorageKey.menuRights, JSON.stringify(this.menuRights));
        this.storageService.menuListSubject.next(true);
      });
    } else {
      this.menuRights = [];
      this.storageService.setValue(StorageKey.menuRights, JSON.stringify(this.menuRights));
      this.storageService.menuListSubject.next(true);
    }

    this.navigateAfterOtpLogin(userData);

    return true;
  }

  private isSubscriptionActive(userData: any): boolean {
    return isPartnerPortalUser(userData?.userType) ||
      userData?.isActive === true ||
      userData?.planExpired === false;
  }

  private navigateAfterOtpLogin(userData: any) {
    if (isPartnerPortalUser(userData?.userType)) {
      this.router.navigate(['/admin/partner-portal']);
      return;
    }

    if (!this.isSubscriptionActive(userData)) {
      this.router.navigate(['/admin/dashboard']);
      return;
    }

    this.router.navigate(['/admin/dashboard']);
  }

  onSendAgainOTP() {
    this.startTimer();

    this.loginService.send_otp('registration', this.ID).subscribe({
      next: (response: any) => {
        if (response.success) {
        }
      }
    });
  }
}
